module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-hover-bg-left.75abfe72.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-hover-bg-left.png
// module id = 3607
// module chunks = 11